export {};

// Stable SVG navigation icons; verified after deployment by the public-site browser smoke test.
const ICONS: Record<string, string> = {
  "nav-home": `
    <svg class="nav-line-icon" data-nav-svg="1" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 10.5 12 4l8 6.5"></path>
      <path d="M6.5 9.5V20h11V9.5"></path>
    </svg>`,
  "nav-history": `
    <svg class="nav-line-icon" data-nav-svg="1" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8"></circle>
      <path d="M12 7.5V12l3 2"></path>
    </svg>`,
  "nav-settings": `
    <svg class="nav-line-icon" data-nav-svg="1" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 7h10"></path>
      <circle cx="17" cy="7" r="2"></circle>
      <path d="M19 7h1"></path>
      <path d="M4 12h3"></path>
      <circle cx="10" cy="12" r="2"></circle>
      <path d="M12 12h8"></path>
      <path d="M4 17h9"></path>
      <circle cx="16" cy="17" r="2"></circle>
      <path d="M18 17h2"></path>
    </svg>`,
};

function installNavIconStyles(): void {
  const style = document.createElement("style");
  style.textContent = `
    .bottom-nav .settings-line-icon { display: none !important; }
    .bottom-nav .nav-line-icon {
      display: block !important;
      width: 24px !important;
      height: 24px !important;
      min-width: 24px !important;
      min-height: 24px !important;
      max-width: 24px !important;
      max-height: 24px !important;
      flex: 0 0 24px !important;
      margin: 0 auto 2px !important;
      overflow: visible !important;
      fill: none !important;
      stroke: currentColor !important;
      stroke-width: 2 !important;
      stroke-linecap: round !important;
      stroke-linejoin: round !important;
    }
    .bottom-nav .nav-line-icon path,
    .bottom-nav .nav-line-icon circle {
      fill: none !important;
      stroke: currentColor !important;
      vector-effect: non-scaling-stroke;
    }
  `;
  document.head.appendChild(style);
}

function applyNavIcons(): void {
  for (const [action, svg] of Object.entries(ICONS)) {
    const button = document.querySelector<HTMLButtonElement>(`.bottom-nav button[data-action="${action}"]`);
    if (!button) continue;
    if (button.querySelector('svg[data-nav-svg="1"]')) continue;
    const oldIcons = button.querySelectorAll("span[aria-hidden='true'], svg[aria-hidden='true']");
    oldIcons.forEach((node) => node.remove());
    button.insertAdjacentHTML("afterbegin", svg);
  }
}

function scheduleApply(): void {
  queueMicrotask(applyNavIcons);
  window.setTimeout(applyNavIcons, 0);
  window.setTimeout(applyNavIcons, 100);
}

installNavIconStyles();
const observer = new MutationObserver(scheduleApply);
observer.observe(document.documentElement, { childList: true, subtree: true });
scheduleApply();
